<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-sound-balance`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M26 3a1 1 0 00-1-1h-2a1 1 0 00-1 1v28a1 1 0 001 1h2a1 1 0 001-1V3zM10 27a1 1 0 011 1v17a1 1 0 01-1 1H8a1 1 0 01-1-1V28a1 1 0 011-1h2zm14 7a6 6 0 110 12 6 6 0 010-12zm17-6a1 1 0 00-1-1h-2a1 1 0 00-1 1v17a1 1 0 001 1h2a1 1 0 001-1V28zM24 38a2 2 0 100 4 2 2 0 000-4zM9 13a6 6 0 110 12 6 6 0 010-12zm36 6a6 6 0 10-12 0 6 6 0 0012 0zM9 17a2 2 0 100 4 2 2 0 000-4zm28 2a2 2 0 114 0 2 2 0 01-4 0zM10 2a1 1 0 011 1v7a1 1 0 01-1 1H8a1 1 0 01-1-1V3a1 1 0 011-1h2zm31 1a1 1 0 00-1-1h-2a1 1 0 00-1 1v7a1 1 0 001 1h2a1 1 0 001-1V3z"/></svg>
</template>
<script>

export default {
  name: 'IconSoundBalance',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
